export default "__VITE_ASSET__DP0616ks__"